import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import Authentication from '../../session';
import { connect } from 'react-redux';
import './styles.scss';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BasicLazyParams } from '../../utile';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { Toast } from 'primereact/toast';
import Service from '../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import moment from 'moment';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';

class TransportFeeReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      filteredUsers: [],
      lazyParams: BasicLazyParams,
      totalRecords: 0,
      routes: [],
      selectedRoute: null,
      stops: [],
      selectedStops: [],
      transportFeeData: [],
      allUsers: [], // Add this line to store all data
    };
    this.service = new Service();
  }

  setDropdownValues = (dropdownsData) => {
    const branchChanged = this.state.dropdownsData?.branchIds !== dropdownsData.branchIds;
    this.setState({
      dropdownsData,
      branchChanged,
      studentsList: [],
      selectedStudents: [],
      dateRange: null
    }, () => {
      let filteredData = [...this.state.allUsers];

      // Apply branch filter
      if (this.state.dropdownsData?.branchIds?.length > 0) {
        filteredData = filteredData.filter(user =>
          this.state.dropdownsData.branchIds.includes(user.studentsInfo.branchId)
        );
      }

      // Apply section filter
      if (this.state.dropdownsData?.sectionIds?.length > 0) {
        filteredData = filteredData.filter(user =>
          this.state.dropdownsData.sectionIds.includes(user.studentsInfo.sectionId)
        );
      }

      const { rows, first } = this.state.lazyParams;
      this.setState({
        filteredUsers: filteredData.slice(first, first + rows),
        totalRecords: filteredData.length
      });
    });
  }

  onPage = (event) => {
    const { first, rows } = event;
    let filteredData = [...this.state.allUsers];

    // Apply all filters
    if (this.state.dropdownsData?.branchIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.branchIds.includes(user.studentsInfo.branchId)
      );
    }

    if (this.state.dropdownsData?.sectionIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.sectionIds.includes(user.studentsInfo.sectionId)
      );
    }

    if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.selectedRoute.includes(user.transportRoute._id)
      );
    }

    if (this.state.selectedStops && this.state.selectedStops.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.selectedStops.some(stop =>
          user.selectedPickUpStop._id === stop ||
          user.selectedDropStop._id === stop
        )
      );
    }

    this.setState({
      lazyParams: { ...this.state.lazyParams, first, rows },
      filteredUsers: filteredData.slice(first, first + rows)
    });
  }

  fetchTransportRoutes = () => {
    const url = `${baseUrlAdmin}/transportReport/transport-fee-report`;
    this.setState({ isLoading: true });
    let payload = {
      academicYear: localStorage.getItem('userAcademicYear'),
    }
    this.service.post(url, payload, true)
      .then(res => {
        if (res?.status && res?.res?.data?.status) {
          const routeInfo = res?.res?.data?.data.routeInfo;
          const allUsers = res?.res?.data?.data.transportFeeInfo;
          const { rows, first } = this.state.lazyParams;

          this.setState({
            routes: routeInfo.map(route => ({
              value: route.routeId,
              label: `${route.routeNumber} - ${route.routeName}`,
              stops: route.stops
            })),
            allUsers,
            filteredUsers: allUsers.slice(first, first + rows),
            totalRecords: allUsers.length,
            isLoading: false
          });
          this.toast.show({ severity: 'success', summary: 'Success', detail: 'Routes fetched successfully', life: 3000 });
        } else {
          this.setState({ isLoading: false });
          this.toast.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch routes', life: 3000 });
        }
      })
      .catch(err => {
        console.error(err);
        this.setState({ isLoading: false });
        this.toast.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch routes', life: 3000 });
      });
  }

  handleRouteChange = (e) => {
    const selectedRoute = this.state.routes.filter(route => e.value.includes(route.value));
    let filteredData = [...this.state.allUsers];

    // Apply branch filter
    if (this.state.dropdownsData?.branchIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.branchIds.includes(user.studentsInfo.branchId)
      );
    }

    // Apply section filter
    if (this.state.dropdownsData?.sectionIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.sectionIds.includes(user.studentsInfo.sectionId)
      );
    }

    // Apply route filter
    if (e.value && e.value.length > 0) {
      filteredData = filteredData.filter(user =>
        e.value.includes(user.transportRoute._id)
      );
    }

    const { rows } = this.state.lazyParams;

    this.setState({
      selectedRoute: e.value,
      /*  stops: selectedRoute ? selectedRoute?.stops.map(stop => ({
         value: stop.stopId,
         label: stop.stopName
       })) : [], */
      stops: selectedRoute.map(route => route.stops).flat().map(stop => ({
        value: stop.stopId,
        label: stop.stopName
      })),
      selectedStops: [], // Reset stops when route changes
      filteredUsers: filteredData.slice(0, rows),
      totalRecords: filteredData.length,
      lazyParams: { ...this.state.lazyParams, first: 0 }
    });
  }

  handleStopChange = (e) => {
    const selectedStops = e.value;
    let filteredData = [...this.state.allUsers];

    // Apply branch filter
    if (this.state.dropdownsData?.branchIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.branchIds.includes(user.studentsInfo.branchId)
      );
    }

    // Apply section filter
    if (this.state.dropdownsData?.sectionIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.sectionIds.includes(user.studentsInfo.sectionId)
      );
    }

    // Apply route filter
    if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.selectedRoute.includes(user.transportRoute._id)
      );
    }

    // Apply stop filter
    if (selectedStops && selectedStops.length > 0) {
      filteredData = filteredData.filter(user =>
        selectedStops.some(stop =>
          user.selectedPickUpStop._id === stop ||
          user.selectedDropStop._id === stop
        )
      );
    }

    const { rows } = this.state.lazyParams;

    this.setState({
      selectedStops: selectedStops,
      filteredUsers: filteredData.slice(0, rows),
      totalRecords: filteredData.length,
      lazyParams: { ...this.state.lazyParams, first: 0 }
    });
  }

  exportToExcel = () => {
    let filteredData = [...this.state.allUsers];

    // Apply all filters
    if (this.state.dropdownsData?.branchIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.branchIds.includes(user.studentsInfo.branchId)
      );
    }

    if (this.state.dropdownsData?.sectionIds?.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.dropdownsData.sectionIds.includes(user.studentsInfo.sectionId)
      );
    }

    if (this.state.selectedRoute && this.state.selectedRoute.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.selectedRoute.includes(user.transportRoute._id)
      );
    }

    if (this.state.selectedStops && this.state.selectedStops.length > 0) {
      filteredData = filteredData.filter(user =>
        this.state.selectedStops.some(stop =>
          user.selectedPickUpStop._id === stop ||
          user.selectedDropStop._id === stop
        )
      );
    }

    // Format data for export
    const exportData = filteredData.map(data => ({
      'Student ID': data.studentsInfo.username.slice(3),
      'Student Name': `${data.studentsInfo.firstName} ${data.studentsInfo.lastName}`,
      'Class-Section': `${data.studentsInfo.className} - ${data.studentsInfo.sectionName}`,
      'Route': data.transportRoute.routeName,
      'Term': data.transportInstallments?.paymentTerm,
      'Due Date': moment(data.transportInstallments?.dueDate).format('DD/MM/YYYY'),
      'Fee Amount': data.transportInstallments?.termWiseActualValue,
      'Paid Amount': data.transportInstallments?.amountPaid,
      'Pending Amount': data.transportInstallments?.termWiseActualValue - data.transportInstallments?.amountPaid
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transport Fee");

    // Generate and download file
    XLSX.writeFile(workbook, `Transport_Fee_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
  }


  componentDidMount() {
    this.fetchTransportRoutes();
  }

  render() {
    const containerStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: window.innerWidth > 1090 ? "50px 0px 0px 95px" : "50px 0px 0px 15px",
      overflow: 'auto',
      transition: 'padding 0.3s',
      paddingBottom: '30px',
    };
    return (
      <>
        <div style={containerStyle} className='m-2'>

          <div className="card filters-card mt-1 pt-0">
            <BranchToSectionMultiDDTillSecReports
              setValues={this.setDropdownValues}
              showTooltip={false}
              tooltip={null}
              tooltipOptions={{ disabled: true }}
            />
            <div className="grid">
              <div className='col-3'>
                <p className='filter-title'>Bus</p>
                <ClassetMultiSelect
                  options={this.state.routes}
                  value={this.state.selectedRoute}
                  optionLabel='label'
                  onChange={this.handleRouteChange}
                  placeholder="Select Route"
                  tooltip={null}
                  showTooltip={false}
                  tooltipOptions={{ disabled: true }}
                />
              </div>
              <div className='col-3'>
                <p className='filter-title'>Stops</p>
                <ClassetMultiSelect
                  options={this.state.stops}
                  value={this.state.selectedStops}
                  optionLabel='label'
                  onChange={this.handleStopChange}
                  placeholder="Select Stops"
                  tooltip={null}
                  showTooltip={false}
                  tooltipOptions={{ disabled: true }}
                  disabled={!this.state.selectedRoute}
                />
              </div>
              <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                <Button
                  label="Download Report"
                  onClick={this.exportToExcel}
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                />
                <Button label="View Analysis" className="p-button-primary"
                  style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
              </div>

            </div>

          </div>
          <div className="datatable-report-demo mx-2">
            <DataTable
              value={this.state.filteredUsers}
              responsiveLayout="scroll"
              dataKey="id"
              paginator
              lazy
              onPage={this.onPage}
              resizableColumns
              first={this.state.lazyParams.first}
              last={this.state.totalRecords}
              rows={this.state.lazyParams.rows}
              totalRecords={this.state.totalRecords}
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              globalFilter={this.state.globalFilter}
              rowClassName={() => 'table-row-style'}
            >
              <Column
                header="Student ID"
                body={(rowData) => {
                  return (
                    <div>
                      {rowData.studentsInfo?.enrollmentId || rowData.studentsInfo?.username?.slice(3) || '-'}
                    </div>
                  )
                }}
              />
              <Column
                header="Student Name"
                body={(rowData) => {
                  return (
                    <div>
                      {rowData.studentsInfo?.name || `${rowData.studentsInfo?.firstName || ''} ${rowData.studentsInfo?.lastName || ''}`.trim() || '-'}
                    </div>
                  )
                }}
              />
              <Column header="Class-Section" field='rowData.studentsInfo.className' body={(rowData) => {
                return (
                  <div>
                    {rowData.studentsInfo?.className && rowData.studentsInfo?.sectionName
                      ? `${rowData.studentsInfo.className} - ${rowData.studentsInfo.sectionName}`
                      : '-'}
                  </div>
                )
              }
              }></Column>
              <Column header="Route" body={(rowData) => {
                return (
                  <div>
                    {rowData.transportRoute.routeName}
                  </div>
                )
              }
              }></Column>
              <Column header="Term" body={(rowData) => {
                return (
                  <div>
                    {rowData.transportInstallments?.paymentTerm || '-'}
                  </div>
                )
              }
              }></Column>
              <Column header="Due Date" body={(rowData) => {
                return (
                  <div>
                    {rowData.transportInstallments?.dueDate ? moment(rowData.transportInstallments.dueDate).format('DD/MM/YYYY') : '-'}
                  </div>
                )
              }}></Column>
              <Column header="Fee Amount" body={(rowData) => {
                return (
                  <div>
                    {rowData.transportInstallments?.termWiseActualValue || rowData.selectedPickUpStop?.transportFee || '-'}
                  </div>
                )
              }
              }></Column>
              <Column header="Paid Amount"
                body={(rowData) => {
                  return (
                    <div>
                      {rowData.transportInstallments?.amountPaid || 0}
                    </div>
                  )
                }}
              ></Column>
              <Column
                header="Pending Amount"
                field='status'
                body={(rowData) => {
                  const feeAmount = rowData.transportInstallments?.termWiseActualValue || rowData.selectedPickUpStop?.transportFee || 0;
                  const paidAmount = rowData.transportInstallments?.amountPaid || 0;
                  return (
                    <div>
                      {feeAmount - paidAmount}
                    </div>
                  )
                }}
              />
            </DataTable>
          </div>
        </div>
        <Toast ref={(el) => this.toast = el} position="bottom-right" />
      </>
    )
  }
}
const mapStatesToProps = (state) => ({
  branchData: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.data.filter((each => {
    if (each.level == 1) {
      return { ...each }
    }
  })) || [],
});
export default connect(mapStatesToProps, {})(Authentication(withRouter(TransportFeeReport)));